/**
 * HotOfferShimmer — skeleton for the Hot Offer / Flash Sale page
 */
const HotOfferShimmer = () => {
    return (
        <div className="bg-gray-100">
            <div className="container mx-auto pt-5 my-5">
                {/* Title */}
                <div className="h-10 w-64 bg-gray-200 rounded animate-pulse mx-auto mb-6" />

                {/* Countdown boxes */}
                <div className="container mx-auto px-4 md:px-10">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mx-1 md:mx-5 justify-center justify-items-center mb-8">
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div
                                key={i}
                                className="w-[150px] md:w-[200px] lg:w-[250px] h-[80px] md:h-[100px] lg:h-[120px] bg-gray-200 rounded animate-pulse"
                            />
                        ))}
                    </div>
                </div>

                {/* Product grid */}
                <div className="container mx-auto px-4 sm:px-6 md:px-10">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div
                                key={i}
                                className="flex flex-col bg-white rounded-[10px] overflow-hidden"
                            >
                                <div className="w-full aspect-product-desktop bg-gray-200 animate-pulse" />
                                <div className="p-2 md:px-3 flex flex-col gap-2">
                                    <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
                                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2" />
                                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/3" />
                                    <div className="flex gap-2 mt-2">
                                        <div className="flex-1 h-8 bg-gray-200 rounded-md animate-pulse" />
                                        <div className="w-10 h-8 bg-gray-200 rounded-md animate-pulse" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotOfferShimmer;
